import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
class GuestRouteBoundaryCore extends React.Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch(error, info) {
        console.error("[GuestRoute] Guest page crashed", error, info);
    }
    render() {
        if (!this.state.failed)
            return this.props.children;
        return (_jsxs("div", { role: "alert", "data-testid": "guest-route-error", style: {
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 14,
                padding: 24,
                boxSizing: "border-box",
                textAlign: "center",
                background: "#12141a",
                color: "#e8eaf0",
            }, children: [_jsx("div", { "aria-hidden": true, style: { fontSize: 40 }, children: "\u26A0\uFE0F" }), _jsx("h2", { style: { margin: 0 }, children: this.props.title }), _jsx("p", { style: { maxWidth: 420, margin: 0, opacity: 0.8 }, children: this.props.description }), _jsx("button", { type: "button", onClick: () => window.location.reload(), style: {
                        marginTop: 6,
                        padding: "11px 20px",
                        borderRadius: 10,
                        border: "1px solid #e8eaf0",
                        background: "transparent",
                        color: "#e8eaf0",
                        cursor: "pointer",
                    }, children: this.props.reloadLabel })] }));
    }
}
export default function GuestRouteErrorBoundary({ children }) {
    const { t } = useTranslation();
    return (_jsx(GuestRouteBoundaryCore, { title: t("magicLink.errors.pageUnavailable"), description: t("magicLink.errors.pageUnavailableHint"), reloadLabel: t("magicLink.errors.reloadPage"), children: children }));
}
